export function contentHasScrollbar(element: HTMLElement) {
  if (element) return element.scrollHeight > element.clientHeight;
}

export function changeBgColorOnMobile(index: number) {
  return index % 2 !== 0 ? 'light' : 'dark';
}
